export const GanttShowOnTaskOptions = {
  SALES_ORDER_ID: 'salesOrderId',
  CLIENT: 'client',
  PRODUCTION_ORDER_NUMBER: 'productionOrderNumber',
  PRODUCTION_ORDER_EXTERNAL_NUMBER: 'productionOrderExternalNumber',
  PROGRESS: 'progress',
  DUE_DATE: 'dueDate',
  TIME: 'time',
  ASSIGNED_WORKERS: 'assignedWorkers',
} as const;

export type GanttShowOnTaskOption = (typeof GanttShowOnTaskOptions)[keyof typeof GanttShowOnTaskOptions];
export type GanttShowOnTaskOptions = Record<GanttShowOnTaskOption, boolean>;

export const KanbanShowOnTaskOptions = {
  ASSIGNED_WORKERS: 'assignedWorkers',
  PRODUCTION_TAGS: 'productionTags',
  SALES_ORDER_ID_CLIENT: 'salesOrderIdClient',
  TECHNOLOGY: 'technology',
  TIME: 'time',
  PRODUCTION_ORDER_NUMBER: 'productionOrderNumber',
  PRODUCTION_ORDER_EXTERNAL_NUMBER: 'productionOrderExternalNumber',
} as const;

export type KanbanShowOnTaskOption = (typeof KanbanShowOnTaskOptions)[keyof typeof KanbanShowOnTaskOptions];
export type KanbanShowOnTaskOptions = Record<KanbanShowOnTaskOption, boolean>;

export const QueueColumnWidthOptions = {
  SHORT: 'short',
  WIDE: 'wide',
} as const;

export type QueueColumnWidthOption = (typeof QueueColumnWidthOptions)[keyof typeof QueueColumnWidthOptions];

export const TaskMainValueOptions = {
  PRODUCT: 'product',
  ID: 'id',
} as const;

export type TaskMainValueOption = (typeof TaskMainValueOptions)[keyof typeof TaskMainValueOptions];
export type TaskMainValueOptions = Record<TaskMainValueOption, boolean>;
